// Flow 10 — the parent proposes an activity (lot 2), split out of Flow 1.
export const FLOW10_TITLE = "Flow 10 — Proposer une activité";

export const FLOW10_STEPS = ["Quoi pratiquer", "Récapitulatif", "Proposition envoyée"];
